import { Box, styled } from '@creditas-ui/react'
import React from 'react'

const ContentDetailsStyle = styled(Box)`
  width: 100%;
  margin-top: 35px;

  @media screen and (min-width: 980px) {
    max-width: 384px;
    margin: auto;
  }
`

const ContentDetails = ({ children }) => (
  <ContentDetailsStyle component="div">{children}</ContentDetailsStyle>
)

export { ContentDetails }
